import styled, { css } from 'styled-components';

import { Button, TextButton } from '@xingternal/button';
import { mediaConfined } from '@xingternal/layout-tokens';
import { spaceL, spaceXL } from '@xingternal/tokens';

import { UploadsList as UploadsListComponent } from '../uploads-list';

export const UploadButton = styled(Button)`
  margin-top: ${spaceL};

  @media ${mediaConfined} {
    margin-top: 0px;
    display: flex;
    margin-left: auto;
  }
`;

export const ReducedUploadButton = styled(TextButton)`
  margin-top: ${spaceL};
`;

export const ErrorBannerWrapper = styled.div`
  margin-top: ${spaceL};
`;

export const UploadsList = styled(UploadsListComponent)<{ $isReduced: boolean }>(
  ({ $isReduced }) => css`
    margin-top: ${$isReduced ? 0 : spaceXL};
  `
);
